module.exports = __webpack_public_path__ + "images/bedrijfswagenleasing9db92b7b113d2663e1f6b35468b8aa50.png";